/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'async-file-submit';
const prefix = `${moduleName}.${componentName}`;

export const uploadFileMessage = `${prefix}.uploadFileMessage`;
export const fileUploadSuccessMessage = `${prefix}.fileUploadSuccessMessage`;
export const selectText = `${prefix}.selectText`;
export const fileUploadError = `${prefix}.fileUploadError`;

export const ENGLISH = {
    [uploadFileMessage]: 'Uploading file',
    [fileUploadSuccessMessage]: 'The file was successfully uploaded.',
    [selectText]: 'Select From Computer',
    [fileUploadError]: 'File upload failed.',
};
